import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

// import { getStore } from 'store';
// import { REDUCER } from 'constants/entity-names';

// // get store
// const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc OffCallDispositionActivity defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { OffCallDispositionActivityService } from 'services/offCallDispositionActivity';
 *
 * // create service instance and send/cancel request
 * const offCallDispositionActivityService = new OffCallDispositionActivityService();
 * const result = await offCallDispositionActivityService.fetchData( '<user-id>' ); // fetch data
 * offCallDispositionActivityService.cancel(); // cancel an active request
 */
export class OffCallDispositionActivityService extends HttpService {

    // fetch component Data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        const { memberId, patientId } = data;
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: { memberId, patientId },
                    data: {},
                }
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    items: get( response, 'body.component.data.state.items', {} ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
